import { apiGet, apiPost, apiPatch } from 'utils/api';


export default class Event {
    // TODO: eventInfo should be single source of truth (it is duplicated in EventStore)
    eventInfo = {}

    fetch() {
        return new Promise((resolve, reject) => {
            apiGet(`events/${_eventId || 'new'}/`).then(response => {
                this.eventInfo = this.deserialize(response.data);
                resolve(this.eventInfo);
            }).catch(error => {
                reject(body);
            });
        });
    }

    deserialize(jsonData) {
        const deserialized = _.clone(jsonData);

        deserialized.start_time = new Date(deserialized.start_time);
        deserialized.end_time = new Date(deserialized.end_time);

        if (deserialized.presale_end_time) {
            deserialized.presale_end_time = new Date(deserialized.presale_end_time);
        } else {
            deserialized.presale_end_time = null;
        }

        return deserialized;
    }

    get(key) {
        return this.eventInfo[key];
    }

    set(key, value) {
        this.eventInfo[key] = value;
    }

    create() {
        return new Promise((resolve, reject) => {
            apiPost(
                'events/',
                this.getSerializedData()
            ).then(response => {
                resolve(response.data);
            }).catch(response => {
                reject(response.data);
            });
        });
    }

    update() {
        return new Promise((resolve, reject) => {
            apiPatch(
                `events/${_eventId}/`,
                this.getUpdateData()
            ).then(response => {
                resolve();
            }).catch(response => {
                reject(response.data);
            });
        });
    }

    getUpdateData() {
        const data = this.getSerializedData();
        // The event products can be created along with the event but not
        // updated. For updating the event products use the event products API.
        delete data.event_products;
        return data;
    }

    getSerializedData() {
        const serializedData = _.clone(this.eventInfo);

        if (serializedData.start_time) {
            serializedData.start_time = serializedData.start_time.toISOString();
        }

        if (serializedData.end_time) {
            serializedData.end_time = serializedData.end_time.toISOString();
        }

        return serializedData;
    }
}

export const eventInstance = new Event();
